import React from 'react';
import PreviewIcon from '@material-ui/icons/SearchOutlined';
import { ICustomTheme } from 'interfaces';
import { useTheme } from '@material-ui/core';

export const CustomPreviewIcon = ({ color }: { color?: string }) => {
  const theme: ICustomTheme = useTheme();
  return (
    <PreviewIcon
      style={{
        color: color || theme.colors.paletteFromBO.main,
        fontSize: theme.typography.h3.fontSize,
      }}
    />
  );
};
